import React from "react";

import identity from "lodash-es/identity";
import { useIntl } from "react-intl";
import { IntlShape } from "react-intl/src/types";

import { SelectEntityDialogProps } from "@app/component/SelectEntityDialog/selectEntityDialogFactory";
import SelectSourceTypesDialog from "@app/component/SelectEntityDialog/SelectSourceTypesDialog";
import SourceType, { getSourceTypeDisplayName, SupportedSources } from "@app/enum/SourceType";

const getRecordTypeMessage =
  (intl: IntlShape) =>
  (key: SupportedSources): string =>
    getSourceTypeDisplayName(intl, key);

const initialRecordTypes: SupportedSources[] = [
  SourceType.WEB,
  SourceType.MOBILE,
  SourceType.IMPORTS,
  SourceType.INTEGRATIONS,
  SourceType.LEAD_GENERATION,
  SourceType.PUBLIC_API,
];

type Props = Omit<
  SelectEntityDialogProps<SupportedSources>,
  "entities" | "getDisplayName" | "getKey" | "id"
>;

export const SourceTypesModal: React.FC<Props> = (props) => {
  const intl = useIntl();

  return (
    <SelectSourceTypesDialog
      entities={initialRecordTypes}
      getDisplayName={getRecordTypeMessage(intl)}
      getKey={identity}
      {...props}
    />
  );
};
